const Verify = () => import('../views/Verify')
const Result = () => import('../views/Result')

export default [
    {
        path: '/Verify',
        name: 'Verify',
        component: Verify
    },
    {
        path: '/Result',
        name: 'Result',
        component: Result
    },

]